import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

/** Selects the updateAccountHeader offer object, falling back to Empty.Object when the key is absent. */
const updateAccountHeaderSelector = createSelector(testTargetOffersSelector, offers => offers.updateAccountHeader || Empty.Object);

export { updateAccountHeaderSelector };
